import { Permission } from '@models/models';

export class SideNavBar {
    constructor(public logo: string, public items: SideNavBarItem[]) {}

    setItemsVisibility(permissions: Permission[]) {
        const permissionsFormated = permissions.map((permission) => {
            return permission.permission_type;
        });
        this.items.forEach((item) => {
            item.setVisible(permissionsFormated);
        });
    }
}

export class SideNavBarItem {
    constructor(
        private label: string,
        private icon: string,
        private route: string,
        private permissions: string[],
        private visible: boolean = false
    ) {}

    setVisible(permissions: string[]): void {
        this.visible = permissions.find((perm) =>
            this.permissions.includes(perm)
        )
            ? true
            : false;
    }
}
